// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  quoteDetails: {
    name: 'quote-details',
    componentName: 'QuoteDetailsWrapper',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/QuoteDetails/QuoteDetailsWrapper.tsx'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/QuoteDetails/QuoteDetailsWrapper.tsx'),
          ).QuoteDetailsWrapper
        : currentRouteName === 'quote-details'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.QuoteDetailsWrapper,
            })),
          );
    },
    // path: `/:context?/${DASHBOARD_PATH}`,
    path: `/:context?/quote/details/:quoteId/customer/:customerId/user/:userId`,
    channel: null,
  },

  home: {
    name: 'dashboard',
    componentName: 'DashboardWrapper',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/Dashboard/DashboardWrapper.tsx'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/Dashboard/DashboardWrapper.tsx'),
          ).DashboardWrapper
        : currentRouteName === 'dashboard'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.DashboardWrapper,
            })),
          );
    },
    // path: `/:context?/${DASHBOARD_PATH}`,
    path: `/:context?/quote/list`,
    channel: null,
  },

  // This is the default path, currently setting to list page
  default: {
    name: 'default',
    componentName: 'Home',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/Home.tsx'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.tsx'))
            .Home
        : currentRouteName === 'default'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Home,
            })),
          );
    },
    path: `/:context?/`,
    channel: null,
  },
});
